export const getSafeMcpReturnTo = (search: string): string | null => {
  const rawReturnTo = new URLSearchParams(search).get('returnTo');
  if (
    !rawReturnTo
    || rawReturnTo.length > 2048
    || !rawReturnTo.startsWith('/')
    || rawReturnTo.startsWith('//')
    || rawReturnTo.includes('\\')
  ) {
    return null;
  }

  try {
    const localOrigin = 'https://sminy.local';
    const parsed = new URL(rawReturnTo, localOrigin);
    const requestId = parsed.searchParams.get('request_id')?.trim();

    if (
      parsed.origin !== localOrigin
      || parsed.pathname !== '/mcp/authorize'
      || !requestId
    ) {
      return null;
    }

    return `/mcp/authorize?request_id=${encodeURIComponent(requestId)}`;
  } catch {
    return null;
  }
};

export const getLoginRedirectForLocation = (
  pathname: string,
  search: string,
): string => {
  const safeReturnTo = getSafeMcpReturnTo(
    `?returnTo=${encodeURIComponent(`${pathname}${search}`)}`,
  );
  return safeReturnTo
    ? `/?returnTo=${encodeURIComponent(safeReturnTo)}`
    : '/';
};
